var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bindElement)?_c('img',{staticStyle:{"display":"inline-block"},attrs:{"src":_vm.imgUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }